import React from 'react'
import { useTheme } from '../contexts/ThemeContext'
import { WeatherMoonRegular, WeatherSunnyRegular } from '@fluentui/react-icons'
import { useThemeSwitcherStyles } from './common/styles'
import { mergeClasses } from '@fluentui/react-components'

export const ThemeSwitcher = () => {
	const { theme, toggleTheme } = useTheme()
	const styles = useThemeSwitcherStyles()
	const isDark = theme === 'dark'

	const handleToggle = (e: React.MouseEvent) => {
		e.preventDefault()
		e.stopPropagation()
		toggleTheme()
	}

	const buttonClass = mergeClasses(
		styles.button,
		isDark ? styles.buttonDark : styles.buttonLight
	)

	const sunClass = mergeClasses(
		styles.iconSun,
		isDark ? styles.iconSunDark : styles.iconSunLight
	)

	const moonClass = mergeClasses(
		styles.iconMoon,
		isDark ? styles.iconMoonDark : styles.iconMoonLight
	)

	return (
		<button
			type="button"
			onClick={handleToggle}
			aria-label={`Switch to ${isDark ? 'light' : 'dark'} theme`}
			className={buttonClass}
		>
			<WeatherSunnyRegular className={sunClass} />
			<WeatherMoonRegular className={moonClass} />
		</button>
	)
}